import { render, staticRenderFns } from "./PeriodicTableCell.vue?vue&type=template&id=60565085&scoped=true&"
import script from "./PeriodicTableCell.vue?vue&type=script&lang=js&"
export * from "./PeriodicTableCell.vue?vue&type=script&lang=js&"
import style0 from "./PeriodicTableCell.vue?vue&type=style&index=0&id=60565085&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60565085",
  null
  
)

export default component.exports